import { ErrorDetail } from "../avano-validation/errors-details/errors-details.component";

export interface AvanoButtonBarButtonDetails {
  icon: string;
  label: string;
  group?: AvanoButtonBarGroup;
  noTranslate?: boolean;
  isCallToActionButton?: boolean;
  action?: () => void;
  isDisabled?: boolean;
  errorDetails?: ErrorDetail[];
}

export interface DynamicAvanoButtonBarButtonDetails {
  icon: string | (() => string);
  label: string | (() => string);
  group?: AvanoButtonBarGroup | (() => AvanoButtonBarGroup);
  noTranslate?: boolean | (() => boolean);
  isCallToActionButton?: boolean | (() => boolean);
  action?: () => void;
  isDisabled?: boolean | (() => boolean);
  errorDetails?: ErrorDetail[];
}

export enum AvanoButtonBarGroup {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}
